<template>
  <div class="server-down-container">
    <!-- حباب‌های رنگی پس‌زمینه -->
    <div class="blob blob-cyan"></div>
    <div class="blob blob-pink"></div>
    <div class="blob blob-purple"></div>

    <v-card class="glass-card text-center pa-12 mx-4" max-width="500" elevation="2">
      <img src="/media/images/cage.webp" width="190" height="auto"/>
      <!-- <div class="icon-container mb-6">
        <v-icon size="80" color="primary" class="spin-icon">mdi-cog</v-icon>
        <v-icon size="50" color="pink" class="spin-icon-reverse">mdi-cog</v-icon>
      </div> -->

      <h1 class="text-h5 font-weight-bold mb-4 text--primary">
        سیستم در حال بروزرسانی است
      </h1>
      
      <p class="text-body-1 grey--text text--darken-1 ma-4 mb-8">
        ارتباط با سرور موقتاً قطع شده است. در حال تلاش برای رفع مشکل هستیم، لطفاً چند لحظه دیگر مجدداً تلاش کنید.
      </p>

      <v-btn
        class="btn-buy rounded-lg mb-8 px-8"
        large
        elevation="5"
        @click="retryConnection"
      >
        <v-icon left dark class="mr-2">mdi-refresh</v-icon>
        تلاش مجدد
      </v-btn>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ServerDown",
  methods: {
    retryConnection() {
      // رفرش کردن کامل صفحه برای تلاش مجدد
      window.location.href = "/";
    }
  }
};
</script>

<style scoped>
.server-down-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f6f9; 
  overflow: hidden; 
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.6;
  z-index: 0;
  animation: float 10s ease-in-out infinite;
}

.blob-cyan {
  width: 350px;
  height: 350px;
  background-color: #00bcd4;
  top: -50px;
  left: -50px;
  animation-delay: 0s;
}

.blob-pink {
  width: 450px;
  height: 450px;
  background-color: #ff4081;
  bottom: -100px;
  right: -50px;
  animation-delay: 2s;
}

.blob-purple {
  width: 300px;
  height: 300px;
  background-color: #9c27b0;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 4s;
}

.glass-card {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.8) !important;
  border-radius: 24px !important;
  box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.07) !important;
  z-index: 1; 
  padding: 30px !important;
}

.icon-container {
  position: relative;
  display: inline-block;
}

.spin-icon {
  animation: spin 4s linear infinite;
}

.spin-icon-reverse {
  position: absolute;
  bottom: -10px;
  right: -15px;
  animation: spin-reverse 3s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spin-reverse {
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-20px) scale(1.05);
  }
}
</style>
